module.exports = __webpack_public_path__ + "static/media/grab.5cc404aa.svg";